var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.425,
    height: 129.299,
    viewBox: "0 0 150.425 129.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20074",
    "data-name": "Group 20074",
    transform: "translate(1.391 1.353)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44036",
    "data-name": "Path 44036",
    d: "M143.181,70.968c6.935,4.989,24.29,16.472,26.521,16.152,3.139-.45,5.688-3,7.893-5.074,6.073,3.722,12.24,7.349,18.216,11.225,3.129,2.029,7.469,4.887,11.268,5.256,3.894.378,10.723-4.148,7.208-8.533-1.714-2.139-4.332-3.551-6.548-5.1-4.48-3.13-9.119-6.019-13.712-8.976,3.888-.019,7.16-4.8,5.947-8.464a7.069,7.069,0,0,0-2.72-3.175c5.81-.539,4.863-7.225,2.482-10.855a12.44,12.44,0,0,0,2.15-2c2.6-3.387.15-7.682-2.6-10.095-2.382-2.092-17.861-11.965-25.916-16.834",
    transform: "translate(-67.336 28.386)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44037",
    "data-name": "Path 44037",
    d: "M196.085,62.418c-4.122-2.394-7.812-5.551-11.958-7.926",
    transform: "translate(-85.807 48.053)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44038",
    "data-name": "Path 44038",
    d: "M121.262,122.242c3.393,2.329,6.768,4.313,10.186,6.372,3.04-3.376,4.967-7.444,7.3-11.286,2.227-3.667,4.838-7.106,7.107-10.754,5.931-9.539,12.735-18.6,18.366-28.333-2.68-1.619-6.6-4.292-10-6.5",
    transform: "translate(-57.448 -27.61)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44039",
    "data-name": "Path 44039",
    d: "M5,136.44c10.222,7.025,48.147,32.9,62.227,39.237C72.872,165.3,80.337,156.1,86.56,146.121c5.789-9.285,11.444-18.827,17.605-27.879-5.669-2.121-50.606-32.656-64.378-40",
    transform: "translate(-5 -78.241)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.c4e5ef508a150bbf0bef9495ceb313e3.svg";
export { ForwardRef as ReactComponent };